import { render, staticRenderFns } from "./DiscreteStudyPD.vue?vue&type=template&id=7aa8fdba&scoped=true&"
import script from "./DiscreteStudyPD.vue?vue&type=script&lang=js&"
export * from "./DiscreteStudyPD.vue?vue&type=script&lang=js&"
import style0 from "./DiscreteStudyPD.vue?vue&type=style&index=0&id=7aa8fdba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa8fdba",
  null
  
)

export default component.exports